//import style global sheet
import '@moeindal/base-raiko-panel-components/dist/index.css';

import './style/App.css';
import './style/background.scss';
import './style/Font.css';
import './style/Scrollbar.scss';
import './style/TextFieldStyle.css'
import './style/CustomizeComponents.css'
import './style/FlexStyle.css'
import './style/TableStyle.scss'
import "./style/Containers.css"
import "./style/ModalStyleSheet.css"
import "./style/CardStyleSheet.scss"
import "./style/Icons.scss"
import "./style/SelectionStyleSheet.css"


//import library
import {ThemeProvider} from '@mui/material';
import {Navigate, Route, Routes} from "react-router-dom";
import CustomTheme from "./theme/CustomTheme";
import PrivateRoute from "./route/PrivateRoute";
import React from "react";
import {RouteHelper} from "./route/RouteHelper";

import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import SignIn from "./pages/signIn/SignIn";
import NotAccess from "./pages/notAccess/NotAccess";
import CompleteRegistration from "./pages/completeRegistration/CompleteRegistration";


const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin]
});

function App() {

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={CustomTheme}>
                <div>
                    <Routes>
                        <Route element={<SignIn/>} path={RouteHelper.SignIn.url}/>
                        <Route element={<NotAccess/>} path={RouteHelper.NotAccess.url}/>
                        <Route
                            path='/panel/*'
                            element={
                                <PrivateRoute/>
                            }
                        />
                        <Route path="*" element={<Navigate replace to="/panel/"/>}/>
                        <Route element={<CompleteRegistration/>} path={RouteHelper.CompleteRegistration.url}/>
                    </Routes>
                </div>

                {/*<PwaInstallPrompt/>*/}
            </ThemeProvider>
        </CacheProvider>
    );
}

export default App;
